/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { defineMessages } from 'react-intl';
import isString from 'lodash/isString';

import { I18NError } from 'Utils';
import { fetchPost } from 'FetchAPIs';
import { formatErrorResponse } from 'responseFormatterFunctions';

const baseHierarchiesDatalakeURL = '/api/datalake/hierarchies';
const baseHierarchiesURL = '/api/hierarchies';

const messages = defineMessages({
  errorCreatingWorkorder: 'Error creating service request. {message}',
  errorValidatingAssetRelations: 'Error validating asset. {message}',
});

export const validateAssetRelationsAPI = (values, userEmailId) =>
  fetchPost(`${baseHierarchiesURL}/hierarchy/asset/validate/relations`, values, {
    userEmailId,
  }).catch(error => {
    throw new I18NError(messages.errorValidatingAssetRelations, {
      message: formatErrorResponse(error.response),
    });
  });

export const createServiceRequestAPI = (alertId, values, userEmailId) =>
  fetchPost(`${baseHierarchiesDatalakeURL}/workspaces/alerts/${alertId}/actions`, values, {
    userEmailId,
  })
    .then(response => ({
      resultJson: {
        SR: {
          TICKETID: isString(response?.resultJson) && JSON.parse(response?.resultJson)?.ticketid,
        },
      }, // workaround to make the API response match the action column in the database
      launchUrl: response?.launchUrl,
    }))
    .catch(error => {
      throw new I18NError(messages.errorCreatingWorkorder, {
        message: formatErrorResponse(error.response),
      });
    });
